import * as THREE from 'three'
import Experience from '../Experience.js'
import EventEmitter from './EventEmitter.js'

export default class Input extends EventEmitter
{
    constructor()
    {
        super()

        this.experience = new Experience();
        this.time = this.experience.time;
        this.sizes = this.experience.sizes;
        this.startTime;
        this.deltaTimeTouch;
        this.firstInteraction = true;
        this.tapTimeThreshold = 150;
        this.mouse = new THREE.Vector2();
        this.delta = new THREE.Vector2();
        // Setup        
        window.addEventListener('pointerdown',(event) =>
        {
            this.pointerDown(event);
        })
        window.addEventListener('pointerup',(event) =>
        {
            this.pointerUp(event);
        })
        window.addEventListener('pointermove',(event) =>
        {
            this.pointerMove(event);
        })
    }

    pointerDown(event)
    {
        this.startTime = this.time.elapsed;
        /*if(this.firstInteraction)
        {        
            this.firstInteraction = false;
        }*/
        this.mouse.x = (event.clientX / this.sizes.width) * 2 - 1;
        this.mouse.y = -(event.clientY / this.sizes.height)* 2 + 1;
        this.trigger('pointerDown');
    }
    pointerMove(event)
    {   
        this.delta.x = ((event.clientX / this.sizes.width) * 2 - 1) - this.mouse.x;
        this.delta.y = -(event.clientY / this.sizes.height)* 2 + 1 - this.mouse.y;
        this.mouse.x = (event.clientX / this.sizes.width) * 2 - 1;
        this.mouse.y = -(event.clientY / this.sizes.height)* 2 + 1;        
    }
    pointerUp(event)
    {
        this.deltaTimeTouch = this.time.elapsed - this.startTime; 
        //console.log(this.delta);
        //console.log(this.deltaTimeTouch)
       if(this.deltaTimeTouch < this.tapTimeThreshold)
       {
            
            this.trigger('pointerUp');
       }
      
        this.trigger('gesture');
    }
}